"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldPolyfill = exports.resolveLocale = void 0;
var localeFallback = {
  pt: 'pt-pt',
  hil: 'fil',
  hye: 'hy',
  cnr: 'sr-me',
  tgl: 'tl',
  'zh-s': 'zh-hans',
  'zh-t': 'zh-hant'
};
var intlToPolyfillLocaleFallback = new Set(['ar', 'az', 'bs', 'pa']);
var resolveLocale = exports.resolveLocale = function resolveLocale(locale) {
  var _localeFallback$lower;
  var lowerCaseLocale = locale.toLowerCase();
  return (_localeFallback$lower = localeFallback[lowerCaseLocale]) !== null && _localeFallback$lower !== void 0 ? _localeFallback$lower : lowerCaseLocale;
};
var shouldPolyfill = exports.shouldPolyfill = function shouldPolyfill(locale) {
  return intlToPolyfillLocaleFallback.has(locale);
};
//# sourceMappingURL=localeFallback.js.map